<template>
  <el-dialog title="上传文件" :visible.sync="isShow" width="500px" :close-on-click-modal="false">
    <el-upload ref="upload" :action="url" multiple :headers="headers" :name="name" :data="otherData" :auto-upload="false" :on-progress="onProgress" :on-success="onSuccess" :on-error="onError">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
    </el-upload>
    <span slot="footer" class="dialog-footer">
      <el-button @click="clearFileList" :loading="updataing">清空列表</el-button>
      <el-button type="primary" @click="submitUpload" :loading="updataing">上 传</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Upload",
  props: {
    accept: {
      type: String,
      default: "image/*, text/*, application/*"
    }
  },
  computed: {
    ...mapState(["userToken"])
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      updataing: false,

      isShow: false,
      url: "",
      name: "file",
      otherData: {},
      headers: {}
    };
  },
  created() {
    this.headers.token = this.userToken;
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit();
    },
    onProgress(event, file, fileList) {
      this.updataing = true;
    },
    onSuccess(response, file, fileList) {
      this.clearFileList();

      this.$message.success("文件上传成功");
      this.updataing = false;

      this.isShow = false;
      this.$emit("onSuccess");
    },
    onError(err, file, fileList) {
      this.$message.error("文件上传失败");
      this.updataing = false;
    },
    clearFileList() {
      this.$refs.upload.clearFiles();
    },
    showView(url, name, data) {
      if (!url) {
        this.$message.error("参数出错，缺少上传接口");
        return;
      }
      this.otherData = data || {};
      this.name = name || "file";
      this.url = this.$http.defaults.baseURL + url;
      this.isShow = true;
      // console.log(this.accept);
    }
  }
};
</script>

<style scoped>
</style>
